import * as React from "react"
import { Hero } from "./Hero"
import { Flex, Box } from "rebass/styled-components"
import styled from "styled-components"
import { ContentWrapper } from "../ContentWrapper"
import { theme } from "../../theme"
import { MapExploreMore } from "./MapExploreMore"
import { MockBarChart } from "../common/MockBarChart"

export const Storymap = ({ content }: { content: React.ReactChildren }) => {
  const mapMove = 240
  return (
    <>
      <Hero />

      <StorymapContentWrapper>
        <ContentWrapper maxWidth={"1290px"}>
          <Paper
            pt={["40vw", "calc(40vw + 30px)", "150px"]}
            pb={"120px"}
            p={[0]}
          >
            <StorymapContent>{content}</StorymapContent>
          </Paper>

          <Flex
            style={{
              position: "relative",
              top: 0,
              background: "#f8fbf6",
            }}
            flexDirection="column"
            justifyContent="center"
            alignItems="center"
            pb={"157px"}
            pt={"30px"}
          >
            <Desktop>
              <MapExploreMore
                style={{
                  position: "absolute",
                  left: -mapMove,
                  top: -280,
                  clipPath: `polygon(${mapMove}px 0%, 100% 0%, 100% 100%, ${mapMove}px 100%)`,
                }}
              />
            </Desktop>

            <MockBarChart
              style={{ position: "absolute", right: 50, bottom: 0 }}
            />
          </Flex>
        </ContentWrapper>
      </StorymapContentWrapper>
    </>
  )
}

const overlayHeight = "150px"

export const StorymapContentWrapper = styled.div`
  background: #f8fbf6;

  @media screen and (min-width: ${theme.breakpoints[2]}) {
    padding-bottom: 75px;
    background: linear-gradient(
      180deg,
      ${({ theme }) => theme.colors.bgDark} ${overlayHeight},
      ${({ theme }) => theme.colors.bgLight} ${overlayHeight}
    );
  }
`
export const Paper = styled(Flex)`
  background-color: #f8fbf6;

  @media screen and (min-width: ${theme.breakpoints[2]}) {
    margin-top: 0px;
    border-radius: 220px 0px 0px 0px;
  }
`

const StorymapContent = styled(ContentWrapper)`
  display: flex;
  flex-direction: column;
  padding: 50% 0px 100px;
  position: relative;

  > * {
    margin: auto;
    margin-bottom: 28px;
    max-width: 650px;

    font-family: Arnhem;
    font-style: normal;
    font-weight: 300;
    font-size: 20px;
    line-height: 170%;

    color: #1b4942;
  }

  p strong {
    font-family: Arnhem;

    text-decoration: underline;
    font-weight: 500;
    font-size: 20px;
    line-height: 34px;
    color: ${({ theme }) => theme.colors.link};
  }

  h1 {
    width: 100%;
    text-align: left;
    font-family: Gentona-Medium;
    font-size: 26px;
    line-height: 123.6%;
    font-weight: bold;
    color: #1b4942;
    :not(:first-child) {
      margin-top: 20px;
    }
  }

  .note {
    font-size: 12px;
    font-style: italic;
  }

  .fullwidth {
    max-width: 100%;
    width: 100%;
  }

  img {
    margin-bottom: 0;
  }

  a {
    text-decoration: none;
    color: ${({ theme }) => theme.colors.link};
  }

  h1 a {
    color: #1b4942;
  }

  @media screen and (min-width: ${theme.breakpoints[0]}) {
    padding: 20px;
    padding-top: 0px;
  }
`
const Desktop = styled(Box)`
  display: none;
  @media screen and (min-width: ${({ theme }) => theme.breakpoints[2]}) {
    display: block;
  }
`
